'use client'

import React from 'react'
import classnames from 'classnames'
import {LinkProps} from 'next/link'

import {TPlatform, usePlatform} from '../../../hooks/usePlatform'
import {btn} from '../../../ui/styleGenerators/button'
import {Icon} from '../Icon/Icon'
import {TIcon} from '../Icon/types'
import {platformToIconMap} from './constants'

import btnStyles from '../../../ui/styleGenerators/button/styles.module.css'
import styles from './styles.module.css'

// вариант 'platform' значит, что надо брать иконку, соответствующую платформе из usePlatform
export type TAppButtonIcon =
  | 'platform'
  | 'googlePlay'
  | 'googlePlayBlack'
  | 'appStore'
  | 'appStoreBlack'
  | 'yandexPro'
  | 'yandexGo'

export type TAppButtonProps = {
  href?: string
  hrefByPlatform?: Partial<Record<TPlatform, string>>
  variant?: 'primary' | 'hollow'
  stretchToFillContainer?: boolean
  icons?: TAppButtonIcon[]
  invertColors?: boolean
  className?: string
}

export function AppButton(props: TAppButtonProps & Omit<LinkProps, 'href'>) {
  const platform = usePlatform()

  const {
    href,
    hrefByPlatform,
    variant = 'primary',
    stretchToFillContainer = false,
    icons = ['platform'],
    invertColors,
    className,
    ...linkProps
  } = props

  let actualHref: string

  if (href !== undefined) {
    actualHref = href
  } else if (hrefByPlatform !== undefined) {
    actualHref = hrefByPlatform[platform ?? 'android']
  }

  return (
    <a
      href={actualHref}
      className={classnames(
        btn({
          isLink: true,
          variant,
          size: 'xl',
          stretchToFillContainer,
          shape: 'boxy',
          invertColors,
        }),
        styles.root,
        {[styles.singleIcon]: icons.length <= 1},
        className,
      )}
      {...linkProps}
    >
      {icons.map((icon, i) => {
        if (icon === 'platform') {
          icon = platformToIconMap.get(platform ?? 'android')
        }

        return <Icon className={btnStyles.img} key={i.toString()} name={icon as TIcon} size="l" />
      })}
    </a>
  )
}
